document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu toggle
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('site-header__nav--open');
    });
  }

  // Product image thumbnail swap
  document.querySelectorAll('.product-page__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.getElementById('ProductMainImage');
      if (main) main.src = thumb.getAttribute('data-full');
    });
  });

  // Option pill -> reflect into variant select (basic single-option sync)
  document.querySelectorAll('.option-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      pill.parentElement.querySelectorAll('.option-pill').forEach(function (p) {
        p.classList.remove('option-pill--selected');
      });
      pill.classList.add('option-pill--selected');
    });
  });
});
